var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#C5C6C9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15896_6503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52036 12.0532C4.12296 12.0533 3.74183 11.8954 3.46106 11.6141L0.258452 8.41271C-0.0861507 8.068 -0.0861507 7.50922 0.258452 7.16451C0.603165 6.81991 1.16194 6.81991 1.50666 7.16451L4.52036 10.1782L12.4933 2.20523C12.8381 1.86063 13.3968 1.86063 13.7415 2.20523C14.0862 2.54994 14.0862 3.10872 13.7415 3.45344L5.57966 11.6141C5.29889 11.8954 4.91776 12.0533 4.52036 12.0532Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15896_6503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.77a5d72d0fcd9170a8e8abb291b39693.svg";
export { ForwardRef as ReactComponent };